import type { WatchCreateMessageProps } from "./useWatchCreateMessage";
import { useReactiveVar } from "@apollo/client";
import isObject from "lodash/isObject";
import { FC, useCallback } from "react";
import { useMatch } from "react-router-dom";
import { useWatchUpdateMessageDataSubscription } from "~@/graphql/codegen/generated";
import { selectedChannelsTypesVar } from "~@/reactive-variables";

// Компонент для подписки на обновления данных сообщений
const WatchUpdateMessageData: FC<WatchCreateMessageProps> = ({
  channelType,
}) => {
  const match = useMatch("/chats/:chatRoomId");

  // Подписка на обновления данных сообщений
  useWatchUpdateMessageDataSubscription({
    variables: {
      channelType,
    },
    onData({ data: { data }, client: { cache } }) {
      const newMessageData = data?.watchUpdateMessageData; // Новые данные сообщения

      if (
        isObject(newMessageData) && // Проверка, что новые данные являются объектом
        match?.params.chatRoomId !== newMessageData.chatRoomId // Проверка, что ID комнаты чата не совпадает с текущим
      ) {
        // Модификация кэша для обновления количества непрочитанных сообщений
        cache.modify({
          id: cache.identify({
            id: newMessageData.chatRoomId,
            __typename: "RoomOutput2",
          }),
          fields: {
            unreadMessagesNumber() {
              return newMessageData.unreadMessagesNumber; // Обновление количества непрочитанных сообщений
            },
          },
        });
      }
    },
  });

  return null; // Компонент не отображает ничего в UI
};

// Хук для отслеживания обновлений данных сообщений
const useWatchUpdateMessageData = () => {
  const selectedChannelsTypes = useReactiveVar(selectedChannelsTypesVar); // Получаем выбранные типы каналов

  // Функция для создания компонентов подписки на обновления данных сообщений для каждого типа канала
  const watchUpdateMessageData = useCallback(() => {
    return selectedChannelsTypes.map((selectedChannelType) => {
      return (
        <WatchUpdateMessageData
          key={selectedChannelType}
          channelType={selectedChannelType}
        />
      );
    });
  }, [selectedChannelsTypes]);

  return watchUpdateMessageData; // Возвращаем функцию для использования в компонентах
};

export default useWatchUpdateMessageData;
